import { provideWidgetClass } from "scrivito"

const paddingXValues = ["px-0", "px-1", "px-2", "px-3", "px-4", "px-5"]
const paddingYValues = ["py-0", "py-1", "py-2", "py-3", "py-4", "py-5"]
const alignmentValues = [
  "align-items-start",
  "align-items-center",
  "align-items-end"
]

export const CardWidget = provideWidgetClass("CardWidget", {
  attributes: {
    content: "widgetlist",
    maxWidth: "integer",
    outerPaddingX: ["enum", { values: paddingXValues }],
    outerPaddingY: ["enum", { values: paddingYValues }],
    innerPaddingX: ["enum", { values: paddingXValues }],
    innerPaddingY: ["enum", { values: paddingYValues }],
    alignment: ["enum", { values: alignmentValues }],
    elevated: "boolean"
  }
})
